// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__q5YrC","strasse":"Footer_strasse__npRt1","rownowrap":"Footer_rownowrap__dhPFI","footertitle":"Footer_footertitle__JWaxA"};